export enum PartnerSyncStatus {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  REPLACED = 'replaced',
  FAILED = 'failed',
  SUBMITTED = 'submitted',
}

export enum TaskStatus {
  COMPLETED = 'completed',
  SUBMITTED = 'submitted',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  ENQUEUED = 'enqueued',
  PROCESSING = 'processing',
}

export interface Person {
  firstName: string
  lastName: string
}

export interface Client {
  companyName: string
}

export interface PartnerBenefitEvent {
  id: string
  eventType: string
  eventData: Record<string, any>
  createdTimestamp: string
}

export interface Task {
  id: string
  partnerBenefitName: string
  employeePublicKey?: string
  taskStatus: TaskStatus
  partnerSyncStatus: PartnerSyncStatus
  person: Person
  client: Client
  syncRequestReason: string
  createdTimestamp: string
  partnerBenefitEvent?: PartnerBenefitEvent[]
}

export interface TasksResponse {
  tasks: Task[]
  nextCursor?: string
  hasNextPage: boolean
}

export interface FilterModel {
  [key: string]: {
    filter?: string
    values?: string[]
  }
}

export interface SortModel {
  colId: string
  sort: 'asc' | 'desc'
}

export interface QueryParams {
  limit: number
  cursor?: string
  personFirstName?: string
  personLastName?: string
  clientCompanyName?: string
  taskStatus?: string
  partnerSyncStatus?: string
  attention?: string
  employeePublicKey?: string
  partnerBenefitName?: string
  sortBy?: string
  sortOrder?: string
}
